var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-list-cont"},[_c('div',{staticClass:"page-list-form"},[_vm._t("form")],2),_c('div',{staticClass:"page-list-table"},[_vm._t("show")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }